/**
 * The old Reports page. The general ledger lives at /accounting/general-ledger and the three
 * periodic reports are tabs on Home (`/accounting?tab=…`); an old link or bookmark takes one hop.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

import { resolveLegacyReportsLocation } from '@/features/accounting/lib/nav'

export const Route = createFileRoute('/_shell/accounting/reports')({
  beforeLoad: ({ search }) => {
    const target = resolveLegacyReportsLocation(search as Record<string, unknown>)
    throw redirect({ to: target.to, search: target.search, replace: true })
  },
})
